/**
 * @packageDocumentation
 * @module api.functional.auth.change_password
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { ChangePasswordDto } from "../../../structures/ChangePasswordDto";
import type { ServiceResponseboolean } from "../../../structures/ServiceResponseboolean";

/**
 * @controller AuthController.changePassword
 * @path POST /auth/change-password
 * @accessor api.functional.auth.change_password.changePassword
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function changePassword(
  connection: IConnection,
  body: changePassword.Body,
): Promise<changePassword.Output> {
  return PlainFetcher.fetch(
    {
      ...connection,
      headers: {
        ...connection.headers,
        "Content-Type": "application/json",
      },
    },
    {
      ...changePassword.METADATA,
      template: changePassword.METADATA.path,
      path: changePassword.path(),
    },
    body,
  );
}
export namespace changePassword {
  export type Body = ChangePasswordDto;
  export type Output = ServiceResponseboolean;

  export const METADATA = {
    method: "POST",
    path: "/auth/change-password",
    request: {
      type: "application/json",
      encrypted: false,
    },
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 201,
  } as const;

  export const path = () => "/auth/change-password";
}
